import { UrlConstants } from "../url.constants";
export class ApiChecklistConstants {
    static URL = UrlConstants.API_V2 + "Checklist";
    static FUNCTION_MARK_AS_NOT_COMPLETE = "MarkAsNotComplete";
    static FUNCTION_MARK_AS_COMPLETED = "MarkAsCompleted";
}
